export const isEmailUrl = (str: string): boolean => {
  return str.startsWith('mailto:')
}
